<template>
  <div id="apple">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "apple",
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}

body{
  overflow-x: hidden;
  width: 19.2rem;


}
#apple {
  width: 19.2rem;
  overflow: hidden;
  font-family: "Microsoft Yahei";

}
input,textarea{border:0;outline:none}
</style>


// WEBPACK FOOTER //
// src/Apple.vue